import * as React from 'react';
import { toast } from 'react-toastify';
import { NavLink, useNavigate } from 'react-router-dom';
import { CheckPermissions, GetQuery } from './Shared';

const ReportListData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [systemCompanyId, setSystemCompanyId] = React.useState(2);
    const [permissions, setPermissions] = React.useState<string[]>([]);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            getReportPermissions();
        } else {
            navigate("/accessdenied");
        }
    }

    const getReportPermissions = async () => {
        const apiUrl = "GetReportPermissionsByUserId";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setSystemCompanyId(result.data.systemCompanyId);
            setPermissions(result.data.reportPermissions);
            setLoading(false);
        }
    }

    const renderDetails = (
        <div>
            <div><h1>Reports</h1></div>
            <div className={systemCompanyId === 2 && permissions.indexOf("RunJobKpiReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/jobkpis'} >
                    Job KPI's
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunItemsOnHireReports") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/itemsonhiresummary'} >
                    Items on Hire Summary
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunItemsOnHireReports") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/itemsonhire'} >
                    Items on Hire Currently
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunItemsOnHireReports") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/itemsonhirebydate'} >
                    Items on Hire / Scheduled By Date
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunPrepaidHireEndingReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/prepaidhireending'} >
                    Prepaid Customers with Hire Period Ending
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunJobQuoteReports") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/jobquote'} >
                    Job {systemCompanyId === 3 ? "Orders" : "Quote"} by Product/Item
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunJobQuoteReports") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/jobquotesummary'} >
                    Job {systemCompanyId === 3 ? "Order" : "Quote"} Summary
                </NavLink>
            </div>
            <div className={systemCompanyId === 3 && permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/csrsalessummary'}>
                    CSR Sales Summary
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/salesbyproduct'} >
                    Sales by Product
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/salesbybranchsummary'}>
                    Sales by Branch Summary
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/salesbybranchandproductgroupsummary'} >
                    Sales by Branch by Product Group Summary
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/jobsummarybyproductgroup'}>
                    Job Summary by Product Group
                </NavLink>
            </div>
            <div className={systemCompanyId === 3 && permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/epajobs'}>
                    EPA Jobs
                </NavLink>
            </div>
            <div className={systemCompanyId === 2 && permissions.indexOf("RunTruckJobChecksReports") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/truckchecksgrouped'} >
                    Truck/Tool Checklist
                </NavLink>
            </div>
            <div className={systemCompanyId === 2 && permissions.indexOf("RunTruckJobChecksReports") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/truckchecks'} >
                    Truck/Tool Checklist (OLD)
                </NavLink>
            </div>
            <div className={systemCompanyId === 2 && permissions.indexOf("RunTruckJobChecksReports") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/jobchecks'} >
                    Job Checklist
                </NavLink>
            </div>
            <div className={systemCompanyId === 2 && permissions.indexOf("RunCamerasOnHireReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/camerasonhire'} >
                    Cameras On Hire
                </NavLink>
            </div>
            <div className={systemCompanyId === 3 && permissions.indexOf("RunPowerPolesScheduledReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/powerpolesscheduled'} >
                    Power Poles Scheduled
                </NavLink>
            </div>
            <div className={systemCompanyId === 3 && permissions.indexOf("RunPowerPolesOnHireReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/powerpolesonhire'} >
                    Power Poles On Hire
                </NavLink>
            </div>
            <div className={systemCompanyId === 3 && permissions.indexOf("RunFencePickupsReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/fencingpickedup'} >
                    Fencing Picked Up
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunConditionReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/condition'} >
                    Condition/Dilapidation Report
                </NavLink>
            </div>
            <div className={systemCompanyId === 3 && permissions.indexOf("RunJobsAwaitingPaymentReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/jobsawaitingpayment'} >
                    Jobs Awaiting Payment
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunInvoicesSentToReckonReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/prepaidinvoicessent'} >
                    Prepaid Invoices Sent To Reckon
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunInvoicesSentToReckonReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/invoicessenttoreckon'} >
                    Invoices Sent To Reckon
                </NavLink>
            </div>
            <div className={systemCompanyId === 3 && permissions.indexOf("RunEventJobsSummaryReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/eventjobsummary'}>
                    Event Job Summary
                </NavLink>
            </div>
            <div className={systemCompanyId === 2 && permissions.indexOf("RunCustomerEmailsReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/customeremails'}>
                    Customer Emails
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunCustomerGateCodesReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/customergatecodes'}>
                    Customer Gate Codes
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunCustomersLockedReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/customerslocked'}>
                    Customers Locked
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunCustomerGateCodesReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/customerspricelist'}>
                    Customers by Pricelist
                </NavLink>
            </div>
            <div className={permissions.indexOf("RunDeletedJobsReport") > 0 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reports/deletedjobs'}>
                    Deleted Jobs
                </NavLink>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    )
};

export default ReportListData;